import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getToken, getProfile } from '../Storage/Storage'; // Import your storage functions

const ProtectedRoute = ({ element: Component, allowedRoles }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // Track auth status
  const [userRole, setUserRole] = useState(null); // Track user role
  const [loading, setLoading] = useState(true); // Track loading state

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const token = await getToken();
        if (token) {
          const profile = await getProfile(); // Assuming getProfile fetches the user role
          setUserRole(profile); // Set the user role
          setIsAuthenticated(true); // Set user as authenticated

          // Debug: Print user role and allowed roles
          console.log('User role:', profile);
          console.log('Allowed roles:', allowedRoles);

        } else {
          setIsAuthenticated(false); // Not authenticated
        }
      } catch (error) {
        console.error("Error checking authentication:", error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false); // Stop loading after check
      }
    };

    checkAccess();
  }, [allowedRoles]);

  if (loading) {
    // Optionally, show a loading spinner or message while checking auth
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" />; // Redirect to sign-in page if not authenticated
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/404" />; // Redirect to 404 page if user role is not allowed
  }

  return <Component />; // Render the component if authenticated and authorized
};

export default ProtectedRoute;
